// extracted by mini-css-extract-plugin
module.exports = {"drawerContainer":"SidebarDrawer_drawerContainer__aIp4A"};